import SectionTitleVertical from './SectionTitleVertical';

export default SectionTitleVertical;
